/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { organizationsCreatePortalSession } from "../funcs/organizationsCreatePortalSession.js";
import { organizationsDisableWebhooks } from "../funcs/organizationsDisableWebhooks.js";
import { organizationsEnableWebhooks } from "../funcs/organizationsEnableWebhooks.js";
import { organizationsGenerateWorkOSAdminPortalLink } from "../funcs/organizationsGenerateWorkOSAdminPortalLink.js";
import { organizationsGet } from "../funcs/organizationsGet.js";
import { organizationsGetGateway } from "../funcs/organizationsGetGateway.js";
import { organizationsGetOnboardingStatus } from "../funcs/organizationsGetOnboardingStatus.js";
import { organizationsListInvites } from "../funcs/organizationsListInvites.js";
import { organizationsListSetupTasks } from "../funcs/organizationsListSetupTasks.js";
import { organizationsListUsers } from "../funcs/organizationsListUsers.js";
import { organizationsRemoveUser } from "../funcs/organizationsRemoveUser.js";
import { organizationsRevokeInvite } from "../funcs/organizationsRevokeInvite.js";
import { organizationsRevokeMemberSignIns } from "../funcs/organizationsRevokeMemberSignIns.js";
import { organizationsSendEnterpriseAdminOnboardingEmail } from "../funcs/organizationsSendEnterpriseAdminOnboardingEmail.js";
import { organizationsSendInvite } from "../funcs/organizationsSendInvite.js";
import { organizationsSubmitOnboardingSurvey } from "../funcs/organizationsSubmitOnboardingSurvey.js";
import { organizationsUpdateInviteRole } from "../funcs/organizationsUpdateInviteRole.js";
import { organizationsUpdateSetupTask } from "../funcs/organizationsUpdateSetupTask.js";
import { organizationsVerifyOnboardingHooksSetup } from "../funcs/organizationsVerifyOnboardingHooksSetup.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { CreatePortalSessionResult } from "../models/components/createportalsessionresult.js";
import { GenerateWorkOSAdminPortalLinkResult } from "../models/components/generateworkosadminportallinkresult.js";
import { ListInvitesResult } from "../models/components/listinvitesresult.js";
import { ListSetupTasksResult } from "../models/components/listsetuptasksresult.js";
import { ListUsersResult } from "../models/components/listusersresult.js";
import { OnboardingStatusResult } from "../models/components/onboardingstatusresult.js";
import { Organization } from "../models/components/organization.js";
import { OrganizationGateway } from "../models/components/organizationgateway.js";
import { OrganizationInvitation } from "../models/components/organizationinvitation.js";
import { RevokeSignInsResult } from "../models/components/revokesigninsresult.js";
import { SendEnterpriseAdminOnboardingEmailResult } from "../models/components/sendenterpriseadminonboardingemailresult.js";
import { SetupTask } from "../models/components/setuptask.js";
import { VerifyOnboardingHooksSetupResult } from "../models/components/verifyonboardinghookssetupresult.js";
import {
  CreatePortalSessionRequest,
  CreatePortalSessionSecurity,
} from "../models/operations/createportalsession.js";
import {
  DisableWebhooksRequest,
  DisableWebhooksSecurity,
} from "../models/operations/disablewebhooks.js";
import {
  EnableWebhooksRequest,
  EnableWebhooksSecurity,
} from "../models/operations/enablewebhooks.js";
import {
  GenerateWorkOSAdminPortalLinkRequest,
  GenerateWorkOSAdminPortalLinkSecurity,
} from "../models/operations/generateworkosadminportallink.js";
import {
  GetOnboardingStatusRequest,
  GetOnboardingStatusSecurity,
} from "../models/operations/getonboardingstatus.js";
import {
  GetOrganizationRequest,
  GetOrganizationSecurity,
} from "../models/operations/getorganization.js";
import {
  GetOrganizationGatewayRequest,
  GetOrganizationGatewaySecurity,
} from "../models/operations/getorganizationgateway.js";
import {
  ListInvitesRequest,
  ListInvitesSecurity,
} from "../models/operations/listinvites.js";
import {
  ListOrganizationUsersRequest,
  ListOrganizationUsersSecurity,
} from "../models/operations/listorganizationusers.js";
import {
  ListSetupTasksRequest,
  ListSetupTasksSecurity,
} from "../models/operations/listsetuptasks.js";
import {
  RemoveOrganizationUserRequest,
  RemoveOrganizationUserSecurity,
} from "../models/operations/removeorganizationuser.js";
import {
  RevokeInviteRequest,
  RevokeInviteSecurity,
} from "../models/operations/revokeinvite.js";
import {
  RevokeOrganizationMemberSignInsRequest,
  RevokeOrganizationMemberSignInsSecurity,
} from "../models/operations/revokeorganizationmembersignins.js";
import {
  SendEnterpriseAdminOnboardingEmailRequest,
  SendEnterpriseAdminOnboardingEmailSecurity,
} from "../models/operations/sendenterpriseadminonboardingemail.js";
import {
  SendInviteRequest,
  SendInviteSecurity,
} from "../models/operations/sendinvite.js";
import {
  SubmitOnboardingSurveyRequest,
  SubmitOnboardingSurveySecurity,
} from "../models/operations/submitonboardingsurvey.js";
import {
  UpdateInviteRoleRequest,
  UpdateInviteRoleSecurity,
} from "../models/operations/updateinviterole.js";
import {
  UpdateSetupTaskRequest,
  UpdateSetupTaskSecurity,
} from "../models/operations/updatesetuptask.js";
import {
  VerifyOnboardingHooksSetupRequest,
  VerifyOnboardingHooksSetupSecurity,
} from "../models/operations/verifyonboardinghookssetup.js";
import { unwrapAsync } from "../types/fp.js";

export class Organizations extends ClientSDK {
  /**
   * createPortalSession organizations
   *
   * @remarks
   * Create a webhook portal session.
   */
  async createPortalSession(
    request?: CreatePortalSessionRequest | undefined,
    security?: CreatePortalSessionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<CreatePortalSessionResult> {
    return unwrapAsync(organizationsCreatePortalSession(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * disableWebhooks organizations
   *
   * @remarks
   * Disable  webhooks for the active organization.
   */
  async disableWebhooks(
    request?: DisableWebhooksRequest | undefined,
    security?: DisableWebhooksSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(organizationsDisableWebhooks(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * enableWebhooks organizations
   *
   * @remarks
   * Enable  webhooks for the active organization.
   */
  async enableWebhooks(
    request?: EnableWebhooksRequest | undefined,
    security?: EnableWebhooksSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(organizationsEnableWebhooks(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * generateWorkOSAdminPortalLink organizations
   *
   * @remarks
   * Generate a WorkOS Admin Portal link for the given intent (e.g. dsync, sso).
   */
  async generateWorkOSAdminPortalLink(
    request: GenerateWorkOSAdminPortalLinkRequest,
    security?: GenerateWorkOSAdminPortalLinkSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GenerateWorkOSAdminPortalLinkResult> {
    return unwrapAsync(organizationsGenerateWorkOSAdminPortalLink(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * get organizations
   *
   * @remarks
   * Get the active organization from the session.
   */
  async get(
    request?: GetOrganizationRequest | undefined,
    security?: GetOrganizationSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Organization> {
    return unwrapAsync(organizationsGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getGateway organizations
   *
   * @remarks
   * Get the active organization's gateway: one MCP URL that gives each member every MCP server in the organization they can reach, signed in through the organization's own user session issuer. It is served while the organization owns exactly one organization-level user session issuer, on the platform host, so not for an organization whose custom domain restricts access to an IP allowlist, not while an organization admin has turned it off, and not for a disabled organization. Requires org:read.
   */
  async getGateway(
    request?: GetOrganizationGatewayRequest | undefined,
    security?: GetOrganizationGatewaySecurity | undefined,
    options?: RequestOptions,
  ): Promise<OrganizationGateway> {
    return unwrapAsync(organizationsGetGateway(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getOnboardingStatus organizations
   *
   * @remarks
   * Get the onboarding status for the active organization by checking WorkOS domain verification, SSO connections, and directory sync state.
   */
  async getOnboardingStatus(
    request?: GetOnboardingStatusRequest | undefined,
    security?: GetOnboardingStatusSecurity | undefined,
    options?: RequestOptions,
  ): Promise<OnboardingStatusResult> {
    return unwrapAsync(organizationsGetOnboardingStatus(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listInvites organizations
   *
   * @remarks
   * List pending WorkOS invitations for the active organization.
   */
  async listInvites(
    request?: ListInvitesRequest | undefined,
    security?: ListInvitesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListInvitesResult> {
    return unwrapAsync(organizationsListInvites(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listSetupTasks organizations
   *
   * @remarks
   * List the fixed setup task catalog projected with organization state and completion evidence.
   */
  async listSetupTasks(
    request?: ListSetupTasksRequest | undefined,
    security?: ListSetupTasksSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListSetupTasksResult> {
    return unwrapAsync(organizationsListSetupTasks(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listUsers organizations
   *
   * @remarks
   * List users in the active organization from Speakeasy organization_user_relationships.
   */
  async listUsers(
    request?: ListOrganizationUsersRequest | undefined,
    security?: ListOrganizationUsersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListUsersResult> {
    return unwrapAsync(organizationsListUsers(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * removeUser organizations
   *
   * @remarks
   * Remove a user from the active organization in Speakeasy and delete their WorkOS organization membership.
   */
  async removeUser(
    request: RemoveOrganizationUserRequest,
    security?: RemoveOrganizationUserSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(organizationsRemoveUser(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * revokeInvite organizations
   *
   * @remarks
   * Revoke a pending WorkOS invitation.
   */
  async revokeInvite(
    request: RevokeInviteRequest,
    security?: RevokeInviteSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(organizationsRevokeInvite(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * revokeMemberSignIns organizations
   *
   * @remarks
   * Revoke a member's sign-ins in the active organization, end their identity provider sessions, and revoke every MCP grant made from those sign-ins. Requires organization admin.
   */
  async revokeMemberSignIns(
    request: RevokeOrganizationMemberSignInsRequest,
    security?: RevokeOrganizationMemberSignInsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RevokeSignInsResult> {
    return unwrapAsync(organizationsRevokeMemberSignIns(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * sendEnterpriseAdminOnboardingEmail organizations
   *
   * @remarks
   * Send the enterprise admin onboarding email to one or more recipients. The email links each recipient to the wizard for the active organization. Used by the Platform Admin onboarding tools.
   */
  async sendEnterpriseAdminOnboardingEmail(
    request: SendEnterpriseAdminOnboardingEmailRequest,
    security?: SendEnterpriseAdminOnboardingEmailSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SendEnterpriseAdminOnboardingEmailResult> {
    return unwrapAsync(organizationsSendEnterpriseAdminOnboardingEmail(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * sendInvite organizations
   *
   * @remarks
   * Send a WorkOS invitation for the active organization.
   */
  async sendInvite(
    request: SendInviteRequest,
    security?: SendInviteSecurity | undefined,
    options?: RequestOptions,
  ): Promise<OrganizationInvitation> {
    return unwrapAsync(organizationsSendInvite(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * submitOnboardingSurvey organizations
   *
   * @remarks
   * Record the onboarding survey result. The server picks the use case's default playbook, which decides the setup tasks the wizard walks; progress and assignments are kept.
   */
  async submitOnboardingSurvey(
    request: SubmitOnboardingSurveyRequest,
    security?: SubmitOnboardingSurveySecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListSetupTasksResult> {
    return unwrapAsync(organizationsSubmitOnboardingSurvey(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateInviteRole organizations
   *
   * @remarks
   * Change the role assigned to a pending WorkOS invitation.
   */
  async updateInviteRole(
    request: UpdateInviteRoleRequest,
    security?: UpdateInviteRoleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<OrganizationInvitation> {
    return unwrapAsync(organizationsUpdateInviteRole(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateSetupTask organizations
   *
   * @remarks
   * Update one fixed setup task. The request must include at least one effective update: status, assignee, hidden, or clear_assignee=true. Assignee is mutually exclusive with clear_assignee=true.
   */
  async updateSetupTask(
    request: UpdateSetupTaskRequest,
    security?: UpdateSetupTaskSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SetupTask> {
    return unwrapAsync(organizationsUpdateSetupTask(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * verifyOnboardingHooksSetup organizations
   *
   * @remarks
   * Return recent hook events for the active organization so the onboarding wizard can confirm that coding agent instrumentation is delivering events to Speakeasy. Polled from the confirm-traffic step.
   */
  async verifyOnboardingHooksSetup(
    request?: VerifyOnboardingHooksSetupRequest | undefined,
    security?: VerifyOnboardingHooksSetupSecurity | undefined,
    options?: RequestOptions,
  ): Promise<VerifyOnboardingHooksSetupResult> {
    return unwrapAsync(organizationsVerifyOnboardingHooksSetup(
      this,
      request,
      security,
      options,
    ));
  }
}
